import createSchema from '../schemas/create.json';

// Language dialog: language first, then text, then files side by side.
const VARIANT_LAYOUT = [
  ['languageCode', 1, 1],
  ['title', 2, 1],
  ['description', 3, 1],
  ['pdfFile', 4, 1],
  ['videoFile', 5, 1],
];
export const variantSchema = VARIANT_LAYOUT.map(([name, row, column]) => ({
  ...createSchema.find(field => field.name === name),
  row,
  column,
}));

const versionTuple = value => value.split('.').map(Number);
const byVersionDesc = (left, right) => {
  const a = versionTuple(left);
  const b = versionTuple(right);
  for (let index = 0; index < 3; index += 1) {
    if (a[index] !== b[index]) return (b[index] || 0) - (a[index] || 0);
  }
  return 0;
};

// Admins pick from versions already in use plus the version they are running;
// free text made people guess which versions exist.
export const appVersionOptions = (settings, currentVersion) =>
  [...new Set([...(settings?.knownAppVersions || []), currentVersion])]
    .filter(Boolean)
    .sort(byVersionDesc)
    .map(version => ({ value: version, label: version }));

export const uploadSchema = (
  schema,
  settings,
  current = {},
  disabledLanguages = [],
  editing = false,
) =>
  schema.map(field => {
    if (field.name === 'appVersion')
      return {
        ...field,
        control: 'custom',
        customComponent: 'OptionsSelect',
        options: appVersionOptions(settings, current.appVersion),
      };
    if (field.name === 'category')
      return {
        ...field,
        options: (settings.categories || []).map(category => ({
          value: category,
          label: category,
        })),
      };
    if (field.name === 'modules')
      return {
        ...field,
        options: (settings.modules || []).map(module => ({
          value: module,
          label: {
            localeId: `DOCUMENT_MANAGEMENT_MODULE_${module}`,
            defaultMessage: module,
          },
        })),
      };
    if (field.name === 'languageCode')
      return {
        ...field,
        disabledLanguages,
        ...(editing && { permission: 'READ', readOnly: true }),
      };
    const fileType = {
      pdfFile: 'Pdf',
      videoFile: 'Video',
      thumbnailFile: 'Image',
    }[field.name];
    if (!fileType) return field;
    const file =
      current[
        { pdfFile: 'pdf', videoFile: 'video', thumbnailFile: 'thumbnail' }[
          field.name
        ]
      ];
    return {
      ...field,
      extensions: settings[`allowed${fileType}Extensions`],
      maxSizeMb: settings[`max${fileType}SizeMb`],
      currentFileName: file?.fileName,
      downloadUrl: file?.url,
    };
  });
